import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';
import { ProfileService } from '../services/profile.service';
import { ProfileDto } from './dto/profile';

@Component({
  selector: 'app-panel-start',
  templateUrl: './panel-start.component.html',
  styleUrl: './panel-start.component.css',
})
export class PanelStartComponent {
  isDarkMode = false;
  store: any;
  selectedAvatar: string | null = null;
  profile!: ProfileDto;
  showDeleteModal = false;

  constructor(
    private router: Router,
    private storeData: Store<any>,
    private analitycs: AnalitycsService,
    private profileService: ProfileService,
  ) {
    localStorage.setItem('light', 'dark');
    this.storeData
      .select((state) => state.index.theme)
      .subscribe((theme) => {
        this.isDarkMode = theme === 'dark';
      });
  }
  ngOnInit() {
    this.analitycs.logEvent('perfil_(panel_start)', {
      pantalla: 'perfil',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.selectedAvatar = localStorage.getItem('selectedAvatar') ?? 'assets/images/juan2.png';
    // const storedAvatar = localStorage.getItem('selectedAvatar'); // Obtiene el avatar guardado
    // if (storedAvatar) {
    //   this.selectedAvatar = storedAvatar; // Si existe, se lo asignamos
    // } else {
    //   this.selectedAvatar = 'assets/images/juan1.png'; // Opción predeterminada (Juan)
    // }
    this.getInfo();
  }

  goToEditProfile() {
    this.analitycs.logEvent('ir_a_editar_perfil_desde_panel_start', {
      pantalla: 'panel_start',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.router.navigate(['/edit-profile']);
  }

  async getInfo() {
    const result = await this.profileService.getInfo();
    this.profile = result;
    // console.log(result);
  }

  // Métodos para la modal de eliminación de cuenta
  openDeleteModal() {
    this.analitycs.logEvent('el_usuario_abre_modal_eliminar_cuenta', {
      pantalla: 'profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.showDeleteModal = true;

    // Limpiar localStorage
  }

  closeDeleteModal() {
    this.analitycs.logEvent('el_usuario_se_arrepiente_de_eliminar_cuenta', {
      pantalla: 'profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    this.showDeleteModal = false;
  }

  confirmDeleteAccount() {
    this.analitycs.logEvent('el_usuario_confirma_eliminar_cuenta', {
      pantalla: 'profile',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });
    // Aquí iría la lógica para eliminar la cuenta
    // Por ejemplo, llamar al servicio correspondiente
    // this.profileService.deleteAccount()

    this.showDeleteModal = false;

    localStorage.clear();

    // Limpiar sessionStorage
    sessionStorage.clear();

    // Limpiar caché del navegador
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => {
          caches.delete(name);
        });
      });
    }

    this.router.navigate(['/login']);
    // Opcional: redirigir al usuario a otra página después de confirmar
    // this.router.navigate(['/logout']);
  }
}
